import { render } from "./GameStudio.vue?vue&type=template&id=586ca13b"
import script from "./GameStudio.vue?vue&type=script&lang=js"
export * from "./GameStudio.vue?vue&type=script&lang=js"

import "./GameStudio.vue?vue&type=style&index=0&id=586ca13b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__